import { render, staticRenderFns } from "./member_icon.vue?vue&type=template&id=ecb8dae2&scoped=true"
import script from "./member_icon.vue?vue&type=script&lang=js"
export * from "./member_icon.vue?vue&type=script&lang=js"
import style0 from "./member_icon.vue?vue&type=style&index=0&id=ecb8dae2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb8dae2",
  null
  
)

export default component.exports